import { render, staticRenderFns } from "./edit-us.vue?vue&type=template&id=06c0e694"
import script from "./edit-us.vue?vue&type=script&lang=js"
export * from "./edit-us.vue?vue&type=script&lang=js"
import style0 from "./edit-us.vue?vue&type=style&index=0&id=06c0e694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports